/* eslint-disable complexity, react/prop-types, no-extra-parens */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { IconRefresh, Tooltip, TooltipButton } from '@americanexpress/dls-react';
import merge from 'deepmerge';
import { useEffect, useState } from 'react';
import { tableStyleObject, textAlignLeft } from '../../../styles/dls/tempDlsStyle';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';
import { getFilters } from './DataTableFilterUtil';

export const EnhancedFilter = ({
  onFilter,
  onFilterReset,
}) => {
  const context = useEnhancedDataTableContext();

  const { showLoader } = context;
  const { checkable } = context;
  const { singleRowSelect } = context;
  const { inlineItemAction = false } = context;
  const { totalRows } = context;
  const { clientEndOperation } = context;
  const { tableNm } = context;
  const { expandable } = context;

  const { headers } = context;

  const headerToDisplay = headers.filter((h) => h && h.display === true);

  const [filters, setFilter] = useState(headerToDisplay.map((h) => h.filter));

  const trStyleObject = merge.all([tableStyleObject.table_tr, {}]);

  const tdStyleObject = merge.all([
    tableStyleObject.table_td,
    tableStyleObject.tableBordered_td,
    textAlignLeft,
  ]);

  //  if(showLoader) return null;

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      onFilter(e.filters || filters);
    }
  };

  const onResetIconClick = () => {
    const newFilter = filters.map(() => '');
    console.log('onResetIconClick');
    console.log(newFilter);
    setFilter(newFilter);
    onFilterReset();
  };

  useEffect(() => {
    setFilter(headers.filter((h) => h.display === true)
      .map((h) => h.filter));
  }, [headers]);

  const resetMarkup = () => {
    if (inlineItemAction && checkable) {
      return (
        <ResetIconComponent
          tableNm={tableNm}
          tdStyleObject={tdStyleObject}
          onResetIconClick={onResetIconClick}
          disabled={showLoader}
        />
      );
    }
    return (
      <>
        {showLoader ? (
          checkable && !singleRowSelect && !clientEndOperation && totalRows === 0 ? (
            <td css={tdStyleObject} />
          ) : (
            <ResetIconComponent
              tableNm={tableNm}
              tdStyleObject={tdStyleObject}
              onResetIconClick={onResetIconClick}
              disabled={true}
            />
          )
        ) : (
          <ResetIconComponent
            tableNm={tableNm}
            tdStyleObject={tdStyleObject}
            onResetIconClick={onResetIconClick}
          />
        )}
        {!showLoader && checkable && expandable && <td css={tdStyleObject} />}
      </>
    );
  };

  const markup = getFilters(
    headerToDisplay,
    filters,
    tdStyleObject,
    setFilter,
    onKeyPress,
    tableNm
  );

  if (!inlineItemAction) {
    return (
      <tr id={`${tableNm}-filter-row`} css={trStyleObject}>
        {resetMarkup()}
        {markup}
      </tr>
    );
  }

  return (
    <tr id={`${tableNm}-filter-row`} css={trStyleObject}>
      {/* Render Empty cell for Expandable Action Menu Header */}
      {inlineItemAction && expandable && <td css={tdStyleObject} />}
      {markup}
      {resetMarkup()}
    </tr>
  );
};

EnhancedFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
  onFilterReset: PropTypes.func.isRequired,
};

const ResetIconComponent = ({
  tableNm,
  tdStyleObject,
  onResetIconClick,
  disabled = false,
}) => (
  <td id={`${tableNm}-filter-cell-icon`} css={{ ...tdStyleObject, textAlign: 'center !important' }}>
    <Tooltip
      id={`${tableNm}-table-filter-refresh-tooltip`}
      triggerElement={(
        <TooltipButton
          icon={(
            <IconRefresh
              id={`${tableNm}-filter-cell-refresh-icon`}
              size="md"
              onClick={!disabled && onResetIconClick}
            />
          )}
        />
      )}
      placement="top"
      forcePlacement={true}
    >
      Reset
    </Tooltip>
  </td>
);
